define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');

    ViewController.plugin({
        supportLiveEngagePlugin: true,

        initialize: function (constructorData) {
        },
        touchSession: function () {
            /**
             This method created in order to let the LE framework know that the web agent preform "keep alive"
             even though the web agent prevent default and/or stop propagation.
             */
            ViewController.viewEventsHandler.fireEvent({
                appName: "webAgent",
                UIEvent: ViewController.viewEventsHandler.eventType.TOUCH_SESSION
            });
        },
        dispose: function () {
        }
    });

    // todo - what to export?

});
